import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { ongoingPaymentsSlice } from './ongoingPaymentsSlice';

const persistConfig = {
  key: ongoingPaymentsSlice.name,
  storage,
};

export const ongoingPaymentsPersistReducer = persistReducer(
  persistConfig,
  ongoingPaymentsSlice.reducer,
);
